import React, { Component } from "react";

import race from "../../../../Assets/race.webp";
import porche from "../../../../Assets/porche.webp";
import bridge from "../../../../Assets/bridge.webp";
import testdrive from "../../../../Assets/testdrive.webp";
import sunset from "../../../../Assets/sunset.webp";
import mobile from "../../../../Assets/mobile.webp";

import "./Success.scss";





const cars = [
  {
    carpic: race,
    title: 'Introducing Sapphire. The pinnacle of electric performance.',
    date: 'August 19, 2022 / Engineering'
  },
  {
    carpic: porche,
    title: 'Embrace the dark side.',
    date: 'August 08, 2022 / Engineering'
  },
  {
    carpic: bridge,
    title: 'An update on Flux Air pricing.',
    date: 'May 05, 2022 / Company'
  },
  {
    carpic: testdrive,
    title: 'Next-level collaboration. Next-generation innovation.',
    date: 'May 04, 2022 / Design'
  },
  {
    carpic: sunset,
    title: 'CompanyFlux Air Grand Touring has arrived.',
    date: 'April 12, 2022 / Company'
  },
  {
    carpic: mobile,
    title: 'The Flux app keeps your car at your fingertips.',
    date: 'March 31, 2022 / Engineering'
  },
]


const Success = () => {
  return (
    <div className="main_success">


      <div className="main_succes_header">
        <div className="title">
          Our stories
        </div>
        <button className="btn btn_2">View all</button>
      </div>


      <div className="main_success_card">

        {cars.map((e) => {
          return (
            <>
              <div className="box_1">
                <div className="car_main">
                  <img src={e.carpic} />
                  <div className="title">
                    {e.title}
                  </div>
                  <div className="date">{e.date}</div>
                </div>
              </div>
            </>
          )
        })}
      </div>

    </div>
  );
};

export default Success;
